import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch, AppThunk } from "@/app/store";
import { EnrollmentBillingItem } from "@/modules/eventRegistration/features/EventWaitlist/api/getEnrollmentBilling/types";
import { getEnrollmentBilling } from "@/modules/eventRegistration/features/EventWaitlist/api/getEnrollmentBilling/getEnrollmentBillingApi";

interface EventTransactionsSliceState {
  loadingEnrollmentBilling: boolean;
  enrollmentBillingError: string | null;
  enrollmentBillingItems: EnrollmentBillingItem[];
}

const initialState: EventTransactionsSliceState = {
  loadingEnrollmentBilling: false,
  enrollmentBillingError: null,
  enrollmentBillingItems: [],
};

const eventTransactionsSlice = createSlice({
  name: "eventTransactions",
  initialState,
  reducers: {
    setLoadingEnrollmentBilling(state, action: PayloadAction<boolean>) {
      state.loadingEnrollmentBilling = action.payload;
    },
    setEnrollmentBillingError(state, action: PayloadAction<string | null>) {
      state.enrollmentBillingError = action.payload;
    },
    setEnrollmentBillingItems(
      state,
      action: PayloadAction<EnrollmentBillingItem[]>,
    ) {
      state.enrollmentBillingItems = action.payload;
    },
    clearEventTransactionsState() {
      return initialState;
    },
  },
});

export default eventTransactionsSlice.reducer;

export const {
  setLoadingEnrollmentBilling,
  setEnrollmentBillingError,
  setEnrollmentBillingItems,
  clearEventTransactionsState,
} = eventTransactionsSlice.actions;

export const fetchEnrollmentBillingAction =
  (requestData: { uuid: string }): AppThunk =>
  async (dispatch: AppDispatch) => {
    try {
      dispatch(setLoadingEnrollmentBilling(true));
      dispatch(setEnrollmentBillingError(null));

      const response = await getEnrollmentBilling(requestData);
      dispatch(setEnrollmentBillingItems(response.data));
    } catch (error) {
      const message =
        error instanceof Error
          ? error.message
          : "Failed to fetch enrollment billing data.";
      dispatch(setEnrollmentBillingError(message));
    } finally {
      dispatch(setLoadingEnrollmentBilling(false));
    }
  };
